import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, createSlots as _createSlots, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-filters"
}
const _hoisted_2 = { class: "_mt-6" }
const _hoisted_3 = {
  key: 0,
  class: "gfu-issue__option-collapsible-sub-content-wrapper"
}
const _hoisted_4 = { class: "gfu-issue__option-collapsible-sub-content-text" }
const _hoisted_5 = { class: "gfu-issue__option-collapsible-sub-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "gfu-notificator gfu-notificator--not-empty _ma-0 _mt-3"
}
const _hoisted_9 = {
  key: 0,
  "data-qa": "issue-box-helpful:Yes"
}
const _hoisted_10 = {
  key: 1,
  "data-qa": "issue-box-helpful:No"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["searchTerm"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_issue_card_foldable = _resolveComponent("issue-card-foldable")
  const _component_issue_card = _resolveComponent("issue-card")

  return (_openBlock(), _createElementBlock("div", null, [
    ($props.allowSearch && $props.sections.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_text_field, {
            modelValue: $data.searchTerm,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.searchTerm) = $event)),
            class: "gfu-flex__item--grow _mt-0",
            "display-name": $props.searchFieldLabel,
            placeholder: $props.searchFieldPlaceholder,
            "auto-complete": "off",
            "data-qa": "contact-form-search"
          }, null, 8 /* PROPS */, ["modelValue", "display-name", "placeholder"])
        ]))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.resultsToDisplay, (section) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (section.projectFaqSectionID)
          ? (_openBlock(), _createBlock(_component_issue_card_foldable, {
              id: section.projectFaqSectionID,
              ref_for: true,
              ref: "sections",
              key: section.projectFaqSectionID,
              "show-icons": $props.showIcons,
              header: section.encodedHeader,
              content: section.content,
              "edited-at": section.editedAt,
              "search-term-regex": $data.searchTermRegex,
              onHeaderClick: $event => ($options.onSectionHeaderClick(section)),
              "data-qa": `contact-form-option:${section.projectFaqSectionID}`
            }, _createSlots({ _: 2 /* DYNAMIC */ }, [
              (section.projectFaqSectionID)
                ? {
                    name: "subContent",
                    fn: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        (section.usefullness === undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Faq.FeedbackFormParagraph), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("button", {
                                  class: "gfu-btn gfu-btn--soft gfu-btn--micro gfu-btn--thin gfu-btn--capitalize gfu-btn--accent gfu-issue__option-collapsible-sub-content-button",
                                  onClick: $event => ($options.markSectionUsefulness(section, true)),
                                  "data-qa": "issue-box-button:Yes"
                                }, [
                                  _createVNode(_component_base_icon, {
                                    name: "check-circle",
                                    class: "gfu-btn__icon gfu-issue__option-collapsible-sub-content-button-icon"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.Resources.Common.ModalYesButton), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_6),
                                _createElementVNode("button", {
                                  class: "gfu-btn gfu-btn--soft gfu-btn--micro gfu-btn--thin gfu-btn--capitalize gfu-btn--primary gfu-issue__option-collapsible-sub-content-button",
                                  onClick: $event => ($options.markSectionUsefulness(section, false)),
                                  "data-qa": "issue-box-button:No"
                                }, [
                                  _createVNode(_component_base_icon, {
                                    name: "times-circle",
                                    class: "gfu-btn__icon gfu-issue__option-collapsible-sub-content-button-icon"
                                  }),
                                  _createTextVNode(" " + _toDisplayString(_ctx.Resources.Common.ModalNoButton), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_7)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["gfu-notificator-item gfu-notificator-item--permanent gfu-notificator-item--fill-mobile", [section.usefullness ? 'gfu-notificator-item--positive' : 'gfu-notificator-item--negative']])
                              }, [
                                (section.usefullness === true)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.Resources.format(_ctx.Resources.Faq.PositiveFeedbackSubmittedParagraph, $props.projectName)), 1 /* TEXT */))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                      _createVNode(_component_localize, {
                                        resource: _ctx.Resources.Faq.NegativeFeedbackSubmittedParagraph
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("a", {
                                            href: "",
                                            class: "gfu-link gfu-link--accent-plain",
                                            "format-key": "0",
                                            onClick: _withModifiers($event => ($options.onSectionNegativeFeedbackClick(section)), ["prevent"]),
                                            "data-qa": "issue-box-contact-link"
                                          }, _toDisplayString(_ctx.Resources.Common.ClickHereButton), 9 /* TEXT, PROPS */, _hoisted_11)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"])
                                    ]))
                              ], 2 /* CLASS */)
                            ]))
                      ])
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "show-icons", "header", "content", "edited-at", "search-term-regex", "onHeaderClick", "data-qa"]))
          : (_openBlock(), _createBlock(_component_issue_card, {
              key: section.header,
              header: section.encodedHeader,
              "search-term-regex": $data.searchTermRegex,
              "show-icons": $props.showIcons,
              onHeaderClick: $event => ($options.onSectionHeaderClick(section)),
              "data-qa": `contact-form-option:${section.categoryKey}`
            }, null, 8 /* PROPS */, ["header", "search-term-regex", "show-icons", "onHeaderClick", "data-qa"]))
      ], 64 /* STABLE_FRAGMENT */))
    }), 256 /* UNKEYED_FRAGMENT */)),
    ($props.sections.length === 0)
      ? _renderSlot(_ctx.$slots, "empty-result", { key: 1 })
      : _createCommentVNode("v-if", true),
    _withDirectives(_createElementVNode("div", {
      searchTerm: $data.searchTerm,
      class: "gfu-issue__no-results",
      "data-qa": "contact-form-search:NoResults"
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.Resources.Common.EmptyStateSearchParagraph), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_12), [
      [_vShow, $options.shouldInvokeSearch && $data.searchResults.length === 0]
    ])
  ]))
}